export default __webpack_public_path__ + "static/media/Hewlett_Packard_Enterprise_logo.svg.2754a976.png";